import { render, staticRenderFns } from "./CreateCategoryModal.vue?vue&type=template&id=73737c71&scoped=true&"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCategoryModal.vue?vue&type=style&index=0&id=73737c71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73737c71",
  null
  
)

export default component.exports